export const makeWeeklyTableId = (
  headers: string[],
  col: string,
  index: number
) => {
  const key = `${headers[index]}_status_${col}${index}`;
  return key;
};

export const getDatNameFromId = (id: string) => {
  return id.split("_")[0];
};
